<div class="row">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  d-flex justify-content-between p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <span class="text-white align-self-center">Membres</span>
                <span class="text-white align-self-center">Fonction</span>
                <span class="text-white align-self-center">Total: <span class="text-white">30</span></span>
            </div>
            <div class="p-1" style="height: 70vh; overflow-y: scroll; ">
                <ng-container *ngIf="vue=='list'">
                    <div *ngFor="let d of datas" class="d-flex justify-content-between  border mb-3 p-1" >
                        <div class="d-flex justify-content-start">
                            <div class="me-1">
                              <img [src]="basePath+d.photo" height="50" width="50" class="img-thumbnail" alt="..." style="border-radius: 50%;">
                            </div>
                            <div class="align-self-center">
                              <span class="text-dark h5"><strong><small>{{d.lastname}} {{d.firstname}}</small></strong></span>
                            </div>
                        </div>
                        <div class="align-self-center text-start">
                            <p>Fonction</p>
                        </div>
                        <div class="align-self-center">
                            <p>{{d.fonction}}</p>
                        </div>
                    </div>
                   
                </ng-container>
                <ng-container *ngIf="vue=='photo'">
                    <div class="row" >
                        <div *ngFor="let d of datas" class="col-12 col-md-3 border mb-3">
                            <img [src]="basePath+d.photo" height="150" width="100" class="img-thumbnail" alt="...">
                            <span class="text-dark h6 text-center"><strong><small>{{d.lastname}} {{d.firstname}} {{d.firstname}}</small></strong></span>
                            <br>
                            <span class="text-dark h6 text-center"><strong><small>{{d.fonction}}</small></strong></span>
                        </div>
                    </div>
                 
                </ng-container>
               
            </div>
        </div>
    </div>
   
</div>